import PropTypes from 'prop-types'
import { TileBackFolderCardContainer } from '../../../styled-component'
import { ArrowLeft } from '../../../../../components/stories/atoms/icons/essentials'

const PlanMenuTileBackButton = ({
  hasFolderHistory = false,
  goBackFolder = () => {}
}) => {
  if (!hasFolderHistory) return null

  return (
    <TileBackFolderCardContainer onClick={goBackFolder}>
      <ArrowLeft style={{ width: 144, height: 144 }} />
    </TileBackFolderCardContainer>
  )
}

PlanMenuTileBackButton.propTypes = {
  hasFolderHistory: PropTypes.bool,
  goBackFolder: PropTypes.func
}

export default PlanMenuTileBackButton
